const LocalStorageKeys = {
  AppConfigKey: "bbascan-app-config",
};

export { LocalStorageKeys };
